import React from 'react';

const NoContract: React.FC = () => {
  return (
    <svg viewBox="0 0 38 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36.9999 1L0.999931 0L0.679932 49.6L37.3199 49L36.9999 1ZM23.8199 43.77L22.5299 44.77L18.9099 40.6L14.4799 44.11L13.4799 42.82L17.6599 39.2L14.1799 35.1L15.8899 33.78L19.1599 37.9L23.1599 34.44L24.4899 36.14L20.3699 39.41L23.8199 43.77ZM30.8899 24.77L7.04993 24.68L7.15993 23.04L30.9999 22.59L30.8899 24.77ZM30.8899 17.61L7.04993 17.52L7.15993 15.88L30.9999 15.42L30.8899 17.61ZM30.8899 10.33L7.04993 10.25L7.15993 8.61L30.9999 8.15L30.8899 10.33Z" />
    </svg>
  );
};

export { NoContract };
